import { createContext, useContext } from 'react';

const AuthProviderContext = createContext({});

export function useAuth() {
  return useContext(AuthProviderContext);
}

export function useIsJobCoach() {
  const { user } = useAuth();

  return user?.groups?.includes('jobcoaches');
}

export default AuthProviderContext.Provider;